import { motion } from "framer-motion";

export function MenuItemCard({ item, lang, index }) {
  const title = lang === "el" ? item.el : item.en;
  const subtitle = lang === "el" ? item.en : item.el;
  const desc = lang === "el" ? item.descEl : item.descEn;

  return (
    <motion.article
      data-testid={`menu-item-${index}`}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.4,
        delay: Math.min(index * 0.04, 0.3),
        ease: [0.22, 1, 0.36, 1],
      }}
      className="group relative border-b border-border/50 py-4 last:border-b-0 sm:py-5"
    >
      <div className="flex items-baseline gap-2 sm:gap-3">
        <h3 className="font-display text-lg font-medium leading-tight text-foreground sm:text-[1.65rem]">
          {title}
        </h3>
        <span
          aria-hidden
          className="flex-1 translate-y-[-4px] border-b border-dashed border-gold-muted/40 sm:translate-y-[-6px]"
        />
        <span className="shrink-0 font-display text-lg font-semibold text-gold sm:text-2xl">
          {item.price}
          <span className="ml-0.5 text-xs text-gold-muted sm:text-sm">€</span>
        </span>
      </div>
      {subtitle && subtitle !== title && (
        <p className="mt-0.5 font-sans text-[0.65rem] uppercase tracking-[0.18em] text-gold-muted/80 sm:text-xs">
          {subtitle}
        </p>
      )}
      {desc && (
        <p className="mt-1.5 max-w-2xl text-[13px] leading-relaxed text-muted-foreground sm:mt-2 sm:text-sm">
          {desc}
        </p>
      )}
    </motion.article>
  );
}
